export default __webpack_public_path__ + "img/sagoo/sagoo8_1500.jpg";